import { useRuntimeConfig } from '@/composables/useRuntimeConfig';
import { classesTag } from '@/commons/tags';
import { removeAssentos } from '@/commons/utils';

const { getConfig } = useRuntimeConfig();

export const tipo_cahve_pix_cpf = import.meta.env.VITE_TIPO_CHAVE_PIX_CPF;
export const tipo_cahve_pix_cnpj = import.meta.env.VITE_TIPO_CHAVE_PIX_CNPJ;
export const tipo_cahve_pix_email = import.meta.env.VITE_TIPO_CHAVE_PIX_EMAIL;
export const tipo_cahve_pix_telefone = import.meta.env.VITE_TIPO_CHAVE_PIX_TELEFONE;
export const tipo_cahve_pix_aleatoria = import.meta.env.VITE_TIPO_CHAVE_PIX_ALEATORIA;

export const status_contratacao_iniciada = import.meta.env.VITE_STATUS_CONTRATACAO_INICIADA;
export const status_contratacao_cancelada = import.meta.env.VITE_STATUS_CONTRATACAO_CANCELADA;
export const status_contratacao_apuracao = import.meta.env.VITE_STATUS_CONTRATACAO_APURACAO;
export const status_contratacao_avaliacao = import.meta.env.VITE_STATUS_CONTRATACAO_AVALIACAO;
export const status_contratacao_autorizacao = import.meta.env.VITE_STATUS_CONTRATACAO_AUTORIZACAO;
export const status_contratacao_autorizada = import.meta.env.VITE_STATUS_CONTRATACAO_AUTORIZADA;
export const status_contratacao_naoautorizada = import.meta.env.VITE_STATUS_CONTRATACAO_NAO_AUTORIZADA;
export const status_contratacao_fornecimento = import.meta.env.VITE_STATUS_CONTRATACAO_FORNECIMENTO;
export const status_contratacao_pagamento = import.meta.env.VITE_STATUS_CONTRATACAO_PAGAMENTO;
export const status_contratacao_concluida = import.meta.env.VITE_STATUS_CONTRATACAO_CONCLUIDA;
export const status_contratacao_parecer_juridico = import.meta.env.VITE_STATUS_CONTRATACAO_PARECER_JURIDICO;

export const contratacao_tipo_locacao_reserva = import.meta.env.VITE_TIPO_CONTRATAO_LOCACAO_RESERVA;
export const contratacao_tipo_locacao_contrato = import.meta.env.VITE_TIPO_CONTRATAO_LOCACAO_CONTRATO;

export const status_solicitacao_pendente = import.meta.env.VITE_STATUS_SOLICITACAO_PENDENTE;
export const status_solicitacao_aprovada = import.meta.env.VITE_STATUS_SOLICITACAO_APROVADA;
export const status_solicitacao_ajuste = import.meta.env.VITE_STATUS_SOLICITACAO_AJUSTE;
export const status_solicitacao_contratacao = import.meta.env.VITE_STATUS_SOLICITACAO_CONTRATACAO;
export const status_solicitacao_reprovada = import.meta.env.VITE_STATUS_SOLICITACAO_REPROVADA;
export const status_solicitacao_cancelada = import.meta.env.VITE_STATUS_SOLICITACAO_CANCELADA;
export const status_solicitacao_rascunho = import.meta.env.VITE_STATUS_SOLICITACAO_RASCUNHO;
export const status_solicitacao_pagamento = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO;
export const status_solicitacao_autorizacao = import.meta.env.VITE_STATUS_SOLICITACAO_AUTORIZACAO;
export const status_solicitacao_concluida = import.meta.env.VITE_STATUS_SOLICITACAO_CONCLUIDA;
export const status_solicitacao_fornecimento = import.meta.env.VITE_STATUS_SOLICITACAO_FORNECIMENTO;
export const status_solicitacao_naoautorizada = import.meta.env.VITE_STATUS_SOLICITACAO_NAO_AUTORIZADA;

export const status_solicitacao_relatorio_em_analise = import.meta.env.VITE_STATUS_SOLICITACAO_RELATORIO_EM_ANALISE;
export const status_solicitacao_relatorio_pendente = import.meta.env.VITE_STATUS_SOLICITACAO_RELATORIO_PENDENTE;
export const status_solicitacao_relatorio_aprovado = import.meta.env.VITE_STATUS_SOLICITACAO_RELATORIO_APROVADO;
export const status_solicitacao_relatorio_ajuste = import.meta.env.VITE_STATUS_SOLICITACAO_RELATORIO_AJUSTE;

export const tipo_solicitacao_auxilio_financeiro_pessoa_fisica = import.meta.env.VITE_TIPO_SOLICITACAO_AUXILIO_FINANCEIRO_PESSOA_FISICA;
export const tipo_solicitacao_ajudacusto_estudante = import.meta.env.VITE_TIPO_SOLICITACAO_AJUDACUSTO_ESTUDANTES;
export const tipo_solicitacao_diaria = import.meta.env.VITE_TIPO_SOLICITACAO_DIARIA;
export const tipo_solicitacao_ajudacusto_estudantes_viagem = import.meta.env.VITE_TIPO_SOLICITACAO_AJUDACUSTO_ESTUDANTES_VIAGEM;
export const tipo_solicitacao_hospedagem = import.meta.env.VITE_TIPO_SOLICITACAO_HOSPEDAGEM;
export const tipo_solicitacao_material_consumo = import.meta.env.VITE_TIPO_SOLICITACAO_MATERIAL_CONSUMO;
export const tipo_solicitacao_material_equipamento = import.meta.env.VITE_TIPO_SOLICITACAO_MATERIAL_EQUIPAMENTO;
export const tipo_solicitacao_pagamento_bolsa = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_BOLSA;
export const tipo_solicitacao_pagamento_bolsa_eventual = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_BOLSA_EVENTUAL;
export const tipo_solicitacao_recarga_cartao_corporativo = import.meta.env.VITE_TIPO_SOLICITACAO_RECARGA_CARTAO_CORPORATIVO;
export const tipo_solicitacao_reembolso = import.meta.env.VITE_TIPO_SOLICITACAO_REEMBOLSO;
export const tipo_solicitacao_locacao_veiculo = import.meta.env.VITE_TIPO_SOLICITACAO_LOCACAO_VEICULO;
export const tipo_solicitacao_pagamento_emprestimo = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_EMPRESTIMO;
export const tipo_solicitacao_pagamento_servico = 'Solicitação de ' + import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_SERVICO;
export const tipo_solicitacao_pagamento_material_consumo = 'Solicitação de ' + import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_MATERIAL_CONSUMO;
export const tipo_solicitacao_pagamento_material_permanente = 'Solicitação de ' + import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_MATERIAL_PERMANENTE;
export const tipo_solicitacao_emprestimo = import.meta.env.VITE_TIPO_SOLICITACAO_EMPRESTIMO;
export const tipo_solicitacao_servico_pessoa_juridica = import.meta.env.VITE_TIPO_SOLICITACAO_SERVICO_PESSOA_JURIDICA;
export const tipo_solicitacao_servico_pessoa_fisica = import.meta.env.VITE_TIPO_SOLICITACAO_SERVICO_PESSOA_FISICA;
export const tipo_solicitacao_cadastro_pessoa_juridica = import.meta.env.VITE_TIPO_SOLICITACAO_CADASTRO_PESSOA_JURIDICA;
export const tipo_solicitacao_cancelamento_contrato = import.meta.env.VITE_TIPO_SOLICITACAO_CANCELAMENTO_CONTRATO;
export const tipo_solicitacao_passagem = import.meta.env.VITE_TIPO_SOLICITACAO_PASSAGEM;
export const tipo_solicitacao_pagamento_premiacao = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_PREMIACAO;
export const tipo_solicitacao_servico = import.meta.env.VITE_TIPO_SOLICITACAO_SERVICO;
export const tipo_solicitacao_material = import.meta.env.VITE_TIPO_SOLICITACAO_APENASMATERIAL;
export const tipo_solicitacao_auxilio_financeiro = import.meta.env.VITE_TIPO_SOLICITACAO_AUXILIO_FINANCEIRO;
export const tipo_solicitacao_auxilio_deslocamento = import.meta.env.VITE_TIPO_SOLICITACAO_AUXILIO_DESLOCAMENTO;
export const tipo_solicitacao_pag_servico = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_SERVICO;
export const tipo_solicitacao_pagamento_material = import.meta.env.VITE_TIPO_SOLICITACAO_PAGAMENTO_MATERIAL;
export const tipo_solicitacao_doa = import.meta.env.VITE_TIPO_SOLICITACAO_DOA
export const tipo_solicitacao_ressarcimento_a_apoiada = import.meta.env.VITE_TIPO_SOLICITACAO_RESSARCIMENTO_A_APOIADA;
export const tipo_solicitacao_devolucao_ao_orgao_financiador = import.meta.env.VITE_TIPO_SOLICITACAO_DEVOLUCAO_AO_ORGAO_FINANCIADOR;
export const tipo_solicitacao_cadastro_pessoa_fisica = import.meta.env.VITE_TIPO_SOLICITACAO_CADASTRO_PESSOA_FISICA;
export const tipo_solicitacao_retirada_rendimentos = import.meta.env.VITE_TIPO_SOLICITACAO_RETIRADA_RENDIMENTOS;
export const tipo_solicitacao_suprimento_fundos = import.meta.env.VITE_TIPO_SOLICITACAO_SUPRIMENTO_FUNDOS;
export const tipo_solicitacao_transferencia_bancaria_entre_contas = import.meta.env.VITE_TIPO_SOLICITACAO_TRANSFERENCIA_BANCARIA_ENTRE_CONTAS;
export const tipo_solicitacao_receita_por_encerramento = import.meta.env.VITE_TIPO_SOLICITACAO_RECEITA_POR_ENCERRAMENTO;

export const rubricaMaterialConsumo = import.meta.env.VITE_CODIGO_RUBRICA_MATERIAL_CONSUMO;
export const rubricaMaterialPermanente = import.meta.env.VITE_CODIGO_RUBRICA_MATERIAL_PERMANENTE;
export const rubricaDiaria = import.meta.env.VITE_CODIGO_RUBRICA_DIARIAS;
export const rubricaAuxilioFinanceiro = import.meta.env.VITE_CODIGO_RUBRICA_AUXILIO_FINANCEIRO;
export const rubricaBolsaPesquisador = import.meta.env.VITE_CODIGO_RUBRICA_BOLSA_PESQUISADOR;
export const rubricaBolsaAluno = import.meta.env.VITE_CODIGO_RUBRICA_BOLSA_ALUNO;
export const rubricaServicoPF = import.meta.env.VITE_CODIGO_RUBRICA_SERVICO_PF;
export const rubricaServicoPJ = import.meta.env.VITE_CODIGO_RUBRICA_SERVICO_PJ;
export const rubricaPassagem = import.meta.env.VITE_CODIGO_RUBRICA_PASSAGEM;
export const rubricaVencimentosVantagens = import.meta.env.VITE_CODIGO_RUBRICA_VENCIMENTOS_VANTAGENS;
export const rubricaObrigacoesPatrimoniais = import.meta.env.VITE_CODIGO_RUBRICA_OBRIGACOES_PATRIMONIAIS;
export const rubricaPremiacoes = import.meta.env.VITE_CODIGO_RUBRICA_PREMIACOES;
export const rubricaMaterialDistribuicaoGratuita = import.meta.env.VITE_CODIGO_RUBRICA_MATERIAL_DISTRIBUICAO_GRATUITA;
export const rubricaServicosConsultoria = import.meta.env.VITE_CODIGO_RUBRICA_SERVICOS_CONSULTORIA;
export const rubricaLocacaoMaoDeObra = import.meta.env.VITE_CODIGO_RUBRICA_LOCACAO_MAO_DE_OBRA;
export const rubricaAjudaDeCusto = import.meta.env.VITE_CODIGO_RUBRICA_AJUDA_DE_CUSTO;
export const rubricaAuxilioAlimentacao = import.meta.env.VITE_CODIGO_RUBRICA_AUXILIO_ALIMENTACAO;
export const rubricaObrigacoesTributariasEContributivas = import.meta.env.VITE_CODIGO_RUBRICA_OBRIGACOES_TRIBUTARIAS_E_CONTRIBUTIVAS;
export const rubricaOutrosAuxiliosFinanceirosPF = import.meta.env.VITE_CODIGO_RUBRICA_OUTROS_AUXILIOS_FINANCEIROS_PF;
export const rubricaSentencasJudiciais = import.meta.env.VITE_CODIGO_RUBRICA_SETENCAS_JUDICIAIS;
export const rubricaTransferenciaCorrentes = import.meta.env.VITE_CODIGO_RUBRICA_TRANSFERENCIA_CORRENTES;
export const rubricaObrasEInstalacoes = import.meta.env.VITE_CODIGO_RUBRICA_OBRAS_E_INSTALACOES;
export const rubricaDepreciacaoBens = import.meta.env.VITE_CODIGO_RUBRICA_DEPRECIACAO_BENS;
export const rubricaPerdasNoImobilizado = import.meta.env.VITE_CODIGO_RUBRICA_PERDAS_NO_IMOBILIZADO;
export const rubricaConstituicaoDeProvisoes = import.meta.env.VITE_CODIGO_RUBRICA_CONSTITUICAO_DE_PROVISOES;
export const rubricaPerdasComInvestimentos = import.meta.env.VITE_CODIGO_RUBRICA_PERDAS_COM_INVESTIMENTOS;

export const tipo_cargo_professor = import.meta.env.VITE_TIPO_CARGO_PROFESSOR;

export const status_pagamento_pendente = import.meta.env.VITE_STATUS_PAGAMENTO_PENDENTE;
export const status_pagamento_autorizado = import.meta.env.VITE_STATUS_PAGAMENTO_AUTORIZADO;
export const status_pagamento_confirmado = import.meta.env.VITE_STATUS_PAGAMENTO_CONFIRMADO;
export const status_pagamento_reabilitado = import.meta.env.VITE_STATUS_PAGAMENTO_REABILITADO;
export const status_pagamento_rejeitadocomerro = import.meta.env.VITE_STATUS_PAGAMENTO_REJEITADO_COM_ERRO;
export const status_pagamento_nao_autorizado = import.meta.env.VITE_STATUS_PAGAMENTO_NAO_AUTORIZADO;
export const status_pagamento_emprocessamento = import.meta.env.VITE_STATUS_PAGAMENTO_EM_PROCESSAMENTO;
export const status_pagamento_cancelado = import.meta.env.VITE_STATUS_PAGAMENTO_CANCELADO;
export const status_pagamento_pausado = import.meta.env.VITE_STATUS_PAGAMENTO_PAUSADO;
export const pagamento_remessa = import.meta.env.VITE_PAGAMENTO_REMESSA;
export const exibir_selecao_pagamento = getConfig('EXIBIR_SELECAO_PAGAMENTO', false);

export const membro_tipo_aluno = import.meta.env.VITE_MEMBRO_TIPO_ALUNO;
export const membro_tipo_servidor = import.meta.env.VITE_MEMBRO_TIPO_SERVIDOR;
export const membro_tipo_consultor = import.meta.env.VITE_MEMBRO_TIPO_CONSULTOR;

export const membros_ativos = import.meta.env.VITE_MEMBROS_ATIVOS;
export const membros_aprovados_e_pendentes = import.meta.env.VITE_MEMBROS_APROVADOS_E_PENDENTES;
export const membros_inativos = import.meta.env.VITE_MEMBROS_INATIVOS;
export const membros_aprovados = import.meta.env.VITE_MEMBROS_APROVADOS;
export const membros_cancelados = import.meta.env.VITE_MEMBROS_CANCELADOS;

export const membro_status_pendente = import.meta.env.VITE_MEMBRO_STATUS_PENDENTE;
export const membro_status_aprovado = import.meta.env.VITE_MEMBRO_STATUS_APROVADO;
export const membro_status_ajuste = import.meta.env.VITE_MEMBRO_STATUS_AJUSTE;
export const membro_status_cancelado = import.meta.env.VITE_MEMBRO_STATUS_CANCELADO;
export const membro_status_assinatura = import.meta.env.VITE_MEMBRO_STATUS_ASSINATURA;
export const membro_status_execucao = import.meta.env.VITE_MEMBRO_STATUS_EXECUCAO;

// O contrato novo já vem marcado como coordenador, mas a troca só acontece na aprovação
export const coordenadorAguardandoAprovacao = (membro) => Boolean(membro?.is_coordenador)
    && [membro_status_pendente, membro_status_ajuste, membro_status_assinatura].includes(membro.ultimo_status);

export const rotuloCoordenador = (membro) => coordenadorAguardandoAprovacao(membro)
    ? 'Coordenador (aguardando aprovação)'
    : 'Coordenador';

export const status_projeto_rascunho = import.meta.env.VITE_STATUS_PROJETO_RASCUNHO;
export const status_projeto_emexecucao = import.meta.env.VITE_STATUS_PROJETO_EM_EXECUCAO;
export const status_projeto_inativo = import.meta.env.VITE_STATUS_PROJETO_INATIVO;
export const status_projeto_cancelado = import.meta.env.VITE_STATUS_PROJETO_CANCELADO;
export const status_projeto_concluido = import.meta.env.VITE_STATUS_PROJETO_CONCLUIDO;
export const status_projeto_ativo = import.meta.env.VITE_STATUS_PROJETO_ATIVO

export const opcoesCategoria = [
    { name: 'A', valor: 'A' },
    { name: 'B', valor: 'B' },
    { name: 'C', valor: 'C' },
    { name: 'D', valor: 'D' },
    { name: 'E', valor: 'E' },
    { name: 'AB', valor: 'AB' },
    { name: 'AC', valor: 'AC' },
    { name: 'AD', valor: 'AD' },
    { name: 'AE', valor: 'AE' },
];

// Status da solicitação de projeto -> cor semântica da tag
export const CORES_STATUS_SOLICITACAO = {
    // Não iniciado / inativo -> cinza
    [status_solicitacao_rascunho]: 'cinza',
    [status_solicitacao_cancelada]: 'cinza',
    // Aguardando / em análise
    [status_solicitacao_pendente]: 'roxo',
    'Avaliação': 'azul',
    // Requer ação do solicitante -> laranja (atenção)
    [status_solicitacao_ajuste]: 'laranja',
    // Etapas do fluxo de execução -> cada uma com sua cor
    [status_solicitacao_contratacao]: 'cyan',
    [status_solicitacao_autorizacao]: 'indigo',
    [status_solicitacao_fornecimento]: 'amarelo',
    [status_solicitacao_pagamento]: 'rosa',
    // Sucesso -> verde
    [status_solicitacao_aprovada]: 'verde',
    [status_solicitacao_concluida]: 'verde',
    // Recusado / não autorizado -> vermelho
    [status_solicitacao_reprovada]: 'vermelho',
    [status_solicitacao_naoautorizada]: 'vermelho',
    'Não autorizada': 'vermelho',
};

export function getStatusSolicitacaoProjetoSeveridade(status) {
    return classesTag(CORES_STATUS_SOLICITACAO[status] ?? 'cinza');
};

// Status da solicitação de projeto -> ícone (PrimeIcons)
export const ICONES_STATUS_SOLICITACAO = {
    [status_solicitacao_rascunho]: 'pi-file-edit',
    [status_solicitacao_pendente]: 'pi-eye',
    'Avaliação': 'pi-eye',
    [status_solicitacao_ajuste]: 'pi-file-edit',
    [status_solicitacao_contratacao]: 'pi-hourglass',
    [status_solicitacao_autorizacao]: 'pi-hourglass',
    [status_solicitacao_fornecimento]: 'pi-hourglass',
    [status_solicitacao_pagamento]: 'pi-hourglass',
    [status_solicitacao_aprovada]: 'pi-check-circle',
    [status_solicitacao_concluida]: 'pi-check-circle',
    [status_solicitacao_reprovada]: 'pi-ban',
    [status_solicitacao_cancelada]: 'pi-times-circle',
    [status_solicitacao_naoautorizada]: 'pi-ban',
    'Não autorizada': 'pi-ban',
};

// Status de relatório de viagem / diária -> cor semântica da tag
export const CORES_STATUS_RELATORIO_DIARIA = {
    [status_solicitacao_relatorio_pendente]: 'roxo',
    [status_solicitacao_relatorio_em_analise]: 'azul',
    [status_solicitacao_relatorio_ajuste]: 'laranja',
    [status_solicitacao_relatorio_aprovado]: 'verde',
};

export const ICONES_STATUS_RELATORIO_DIARIA = {
    [status_solicitacao_relatorio_pendente]: 'pi-eye',
    [status_solicitacao_relatorio_em_analise]: 'pi-search',
    [status_solicitacao_relatorio_ajuste]: 'pi-file-edit',
    [status_solicitacao_relatorio_aprovado]: 'pi-check-circle',
};

export function getStatusRelatorioDiariaSeveridade(status) {
    return classesTag(CORES_STATUS_RELATORIO_DIARIA[status] ?? 'cinza');
};

// Status de pagamento -> cor semântica da tag
export const CORES_STATUS_PAGAMENTO = {
    [status_pagamento_pendente]: 'roxo',
    [status_pagamento_autorizado]: 'cyan',
    [status_pagamento_emprocessamento]: 'amarelo',
    [status_pagamento_pausado]: 'laranja',
    [status_pagamento_reabilitado]: 'azul',
    [status_pagamento_confirmado]: 'verde',
    [status_pagamento_rejeitadocomerro]: 'rosa',
    [status_pagamento_nao_autorizado]: 'vermelho',
    [status_pagamento_cancelado]: 'cinza',
};

export const ICONES_STATUS_PAGAMENTO = {
    [status_pagamento_pendente]: 'pi-eye',
    [status_pagamento_autorizado]: 'pi-lock-open',
    [status_pagamento_emprocessamento]: 'pi-hourglass',
    [status_pagamento_pausado]: 'pi-pause-circle',
    [status_pagamento_reabilitado]: 'pi-info-circle',
    [status_pagamento_confirmado]: 'pi-check-circle',
    [status_pagamento_rejeitadocomerro]: 'pi-exclamation-triangle',
    [status_pagamento_nao_autorizado]: 'pi-ban',
    [status_pagamento_cancelado]: 'pi-times-circle',
};

export function getStatusPagamentoSeveridade(status) {
    return classesTag(CORES_STATUS_PAGAMENTO[status] ?? 'cinza');
}

// Status de contratação -> cor semântica da tag
export const CORES_STATUS_CONTRATACAO = {
    // Início / análise -> tons frios distintos por etapa
    [status_contratacao_iniciada]: 'roxo',
    [status_contratacao_apuracao]: 'cyan',
    [status_contratacao_avaliacao]: 'azul',
    'Avaliada': 'laranja', // status sem constante em .env
    // Autorização
    [status_contratacao_autorizacao]: 'indigo',
    [status_contratacao_autorizada]: 'verde',
    // Execução
    [status_contratacao_fornecimento]: 'amarelo',
    [status_contratacao_pagamento]: 'rosa',
    // Encerramento
    [status_contratacao_concluida]: 'verde',
    [status_contratacao_cancelada]: 'cinza',
    // Negado
    [status_contratacao_naoautorizada]: 'vermelho',
    // Pausa para o Jurídico
    [status_contratacao_parecer_juridico]: 'laranja',
};

export const ICONES_STATUS_CONTRATACAO = {
    [status_contratacao_iniciada]: 'pi-hourglass',
    [status_contratacao_apuracao]: 'pi-search',
    [status_contratacao_avaliacao]: 'pi-eye',
    'Avaliada': 'pi-verified',
    [status_contratacao_autorizacao]: 'pi-hourglass',
    [status_contratacao_autorizada]: 'pi-check-circle',
    [status_contratacao_fornecimento]: 'pi-hourglass',
    [status_contratacao_pagamento]: 'pi-hourglass',
    [status_contratacao_concluida]: 'pi-check-circle',
    [status_contratacao_cancelada]: 'pi-times-circle',
    [status_contratacao_naoautorizada]: 'pi-ban',
    [status_contratacao_parecer_juridico]: 'pi-briefcase',
};

export function getStatusContratacaoSeveridade(status) {
    return classesTag(CORES_STATUS_CONTRATACAO[status] ?? 'cinza');
};

// Status de membro do projeto -> cor semântica da tag
export const CORES_STATUS_MEMBRO = {
    [membro_status_pendente]: 'roxo',
    [membro_status_aprovado]: 'verde',
    [membro_status_ajuste]: 'laranja',
    [membro_status_assinatura]: 'indigo',
    [membro_status_execucao]: 'cyan',
    [membro_status_cancelado]: 'cinza',
};

export const ICONES_STATUS_MEMBRO = {
    [membro_status_pendente]: 'pi-eye',
    [membro_status_aprovado]: 'pi-check-circle',
    [membro_status_ajuste]: 'pi-file-edit',
    [membro_status_assinatura]: 'pi-pen-to-square',
    [membro_status_execucao]: 'pi-wrench',
    [membro_status_cancelado]: 'pi-times-circle',
};

export function getStatusMembroSeveridade(status) {
    return classesTag(CORES_STATUS_MEMBRO[status] ?? 'cinza', {
        negrito: status == membro_status_assinatura,
    });
}

export const status_assinatura_cancelado = 'CANCELADO';

// Status de assinatura eletronica de anexo, como vem do back -> rotulo legivel + cor da tag
const STATUS_ASSINATURA = {
    'PENDENTE_ASSINATURA': { label: 'Assinatura Pendente', cor: 'amarelo' },
    'ASSINATURA_PARCIAL': { label: 'Assinatura Parcial', cor: 'azul' },
    'FINALIZADO': { label: 'Finalizado', cor: 'verde' },
    'CANCELADO': { label: 'Cancelado', cor: 'vermelho' },
    'SEM_SOLICITACAO': { label: 'Sem Solicitação', cor: 'cinza' },
};

export function tagStatusAssinatura(status) {
    const chave = removeAssentos(String(status ?? '')).trim().toUpperCase().replace(/\s+/g, '_');
    // Sem status é um anexo que ainda não teve assinatura solicitada.
    if (!chave) return STATUS_ASSINATURA.SEM_SOLICITACAO;
    return STATUS_ASSINATURA[chave] ?? { label: '-', cor: 'cinza' };
}
